export default "__VITE_ASSET__hBG26SUG__"